(function(root){'use strict';
function evaluate(record,input){
 const f=record.facts,reasons=[];if(!record.available||!f)return {eligible:false,reasons:['unavailable']};
 if(input.mode==='extend'&&!f.extension||input.mode!=='extend'&&f.extension)return {eligible:false,reasons:['mode']};
 if(input.mode==='extend'&&(input.count>3||input.count+(input.existingCount??2)>5))return {eligible:false,reasons:['count']};
 if(input.mode!=='extend'&&input.count>f.count)return {eligible:false,reasons:['count']};
 if(input.mode!=='extend'&&f.model==='Hide Away'&&f.count!==Math.max(2,input.count))return {eligible:false,reasons:['unneeded_bays']};
 if(input.size!==null&&input.size>f.litres)return {eligible:false,reasons:['size']};
 reasons.push(input.size===null?'mixed_note':'nominal');
 if(input.bin.some(n=>n!==null)){
  if(f.inner&&!f.extension){if(input.bin.some((v,i)=>v!==null&&((i===0?v*input.count:v)+input.allowance)>f.inner[i]+1e-8))return {eligible:false,reasons:['bin_no']};reasons.push('bin_ok');}
  else reasons.push('unknown_inner');
 }
 if(input.space.some(n=>n!==null)){
  if(f.outer&&!f.extension){if(input.space.some((v,i)=>v!==null&&v+1e-8<f.outer[i]))return {eligible:false,reasons:['space_no']};reasons.push('space_ok');}
  else reasons.push('unknown_outer');
 }
 if(input.mode==='extend')reasons.push('extension_note');if(f.wall)reasons.push('wall_note');
 reasons.push('opening_note');return {eligible:true,reasons,extensionQty:input.mode==='extend'?input.count:0};
}
const api={evaluate};root.KollBinEngine=api;if(typeof module!=='undefined')module.exports=api;
})(typeof window!=='undefined'?window:globalThis);
